import {
  Component,
  EventEmitter,
  Output
} from '@angular/core';


export class SkyActionButtonComponent {
  
  public actionClick = new EventEmitter<any>();

  public buttonClicked() {
    this.actionClick.emit();
  }

  public enterPress() {
    this.actionClick.emit();
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-action-button',
  styles: [`.sky-action-button {
  border-top: 1px solid #cdcfd2;
  border-bottom: 1px solid #cdcfd2;
  border-left: 1px solid #cdcfd2;
  border-right: 1px solid #cdcfd2;
  max-width: 236px;
  cursor: pointer;
  display: inline-block;
  padding-top: 20px;
  padding-right: 20px;
  padding-left: 20px;
  padding-bottom: 30px;
  text-align: center;
}

.sky-action-button:hover {
  border-color: #c2c4c6;
}

@media (min-width: 768px) {
  .sky-action-button {
    padding: 30px 20px;
  }
}

@media (max-width: 767px) {
  .sky-action-button-icon-header-container {
    margin-bottom: 20px;
  }
  .sky-action-button {
    max-width: none;
    display: block;
    margin-left: 15px;
    margin-right: 15px;
  }
}
`],
  template: `<div
  class="sky-action-button sky-btn-default sky-rounded-corners"
  role="button"
  (click)="buttonClicked()"
  (keydown.enter)="enterPress()"
  tabindex="0"
  >
  <div class="sky-action-button-icon-header-container">
    <ng-content select="sky-action-button-icon"></ng-content>
    <ng-content select="sky-action-button-header"></ng-content>
  </div>
  <ng-content select="sky-action-button-details"></ng-content>
</div>
`
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'actionClick': [{ type: Output },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
